import React, { useEffect } from 'react'
import { Outlet, useParams } from 'react-router-dom'

function Main({setShopPath}) {
    const [isLoaded, setIsLoaded] = React.useState(false)
    const [isEnable, setIsEnable] = React.useState(false)

    const {shop} = useParams()

    const params = {
        shop_path: shop,
    }
    const query_params = new URLSearchParams(params); 

    useEffect(() => {
        fetch(process.env.REACT_APP_API_URL + '/api/is_enabled_shop?' + query_params, {
            method: 'GET',
            cache: 'no-store',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        })
        .then(response => response.json())
        .then(data => {
            if (data.is_enabled) {
                setShopPath(shop)
                setIsEnable(true)
            } else {
                setShopPath('')
            }
            setIsLoaded(true)
        }).catch(error => {
            setShopPath('')
            setIsLoaded(true)
        });
    }, [])

    return (
        <>
        {!isLoaded ?
            <div>
                Loading...
            </div>
            :
            <div>
                {isEnable ? <Outlet /> : <NoMatch />}
            </div>
        }
        </>
    )
}

function NoMatch() {
    return (
        <>404 Not Found</>
    );
}

export default Main